import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { useNavigationStore } from '@/store/navigation'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
      }
    }

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ top: 0, behavior: 'smooth' });
      }, 100);
    });
    // return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  try {
    console.log(`Navigating to: ${to.name}`);

    // proxy-router (see router/proxy-router.vue) is a transient redirect step, not a
    // real page - many menu links go THROUGH it (e.g. exam-list -> proxy-router ->
    // settings). Treat it as transparent: while entering it, stash the real page being
    // left so it can still be used as "from" once proxy-router forwards to the real
    // destination, instead of that destination seeing "proxy-router" as its from.
    const navigationStore = useNavigationStore()

    if (to.name === 'proxy-router') {
      if (from.name && from.name !== 'proxy-router') {
        navigationStore.setPendingRealFrom({ name: from.name, meta: from.meta })
      }
    } else {
      const effectiveFrom = from.name === 'proxy-router'
        ? navigationStore.pendingRealFrom
        : (from.name ? { name: from.name, meta: from.meta } : null)

      if (effectiveFrom) {
        navigationStore.setPreviousRoute(effectiveFrom.name)

        // sectionEntryRouteName only updates when actually crossing INTO a section
        // (e.g. exam-list -> settings), not on internal moves within it (settings <->
        // clinic-show/user-show). That's what lets settings' own back label keep
        // pointing at "Exames" even after clinic-show/user-show bounce it back to
        // settings, instead of getting overwritten to whatever sub-page was last visited.
        const enteringNewSection = to.meta?.section && to.meta.section !== effectiveFrom.meta?.section
        if (enteringNewSection) {
          navigationStore.setSectionEntryRoute(effectiveFrom.name)
        }
      }

      if (from.name === 'proxy-router') {
        navigationStore.setPendingRealFrom(null)
      }
    }

    if (to.query._data === 'plans' && to.name !== 'new-plans' && to.name !== 'login') {
      const newQuery = { ...to.query };
      delete newQuery._data;
      next({ name: 'new-plans', query: newQuery, replace: true });
    }

    next();
  } catch(err) {
    console.log("Navigation error:", err)
    next();
  }
});

export default router
